import React from 'react';

type Props = {
  allowedKeys: string[];
  // eslint-disable-next-line no-unused-vars
  onKeyUp: (e: string) => void;
};

const useHotkey = ({ allowedKeys, onKeyUp }: Props) =>
  React.useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      const el = document.activeElement as HTMLElement | null;
      const tag = (el?.tagName ?? '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
      if (el?.isContentEditable) return;
      if (allowedKeys.includes(e.key)) {
        onKeyUp(e.key);
      }
    };

    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [allowedKeys, onKeyUp]);

export default useHotkey;
